import { z } from 'zod';
import {
  GENDER_OPTIONS,
  IP_MIN_LENGTH,
  ISO_COUNTRY_CODE_LENGTH,
  NARRATIVE_MAX_LENGTH,
  NARRATIVE_MAX_MESSAGE,
  NARRATIVE_MIN_LENGTH,
  NARRATIVE_MIN_MESSAGE,
} from '@/services/api/fiu-utr';

export const ISO_COUNTRY_MESSAGE = 'ISO-2 code';

// Inline-error rules mirror the legacy Vuetify rules. Generation itself is
// gated by canGenerate + buildClientDetails (legacy parity), not by form submission —
// this schema only drives the inline error display.
export const fiuUtrFormSchema = z.object({
  // Same copy as canGenerate's threshold and the server zod schema
  narrative: z
    .string()
    .refine((value) => value.length >= NARRATIVE_MIN_LENGTH, NARRATIVE_MIN_MESSAGE)
    .refine((value) => value.length <= NARRATIVE_MAX_LENGTH, NARRATIVE_MAX_MESSAGE),
  ips: z.array(z.string().min(IP_MIN_LENGTH)),
  gender: z.enum(GENDER_OPTIONS).nullable(),
  email: z.string(),
  identificationType: z.string().nullable(),
  identificationNumber: z.string(),
  identificationIssueCountry: z.string().refine((value) => !value || value.length === ISO_COUNTRY_CODE_LENGTH, ISO_COUNTRY_MESSAGE),
});

export type FiuUtrFormValues = z.infer<typeof fiuUtrFormSchema>;

export const DEFAULT_FORM_VALUES: FiuUtrFormValues = {
  narrative: '',
  ips: [],
  gender: null,
  email: '',
  identificationType: null,
  identificationNumber: '',
  identificationIssueCountry: '',
};
